import React from 'react';
import { Button, Spinner, Tooltip } from '@bynder/design-system';
import { Translate, useTranslate } from '@bynder/localization';
import { UploadType, useUploader } from '../../../../hooks/useUploader';
import { IconUpload } from '@bynder/icons';
interface Props {
  uploadType: UploadType;
  canUseUploader: boolean;
  handleUploadCompleted: (mediaId: string) => void;
}

export const ImageWidgetUploader: React.FC<Props> = ({
  uploadType,
  canUseUploader,
  handleUploadCompleted,
}) => {
  const { BynderUploader, handleClick, isConfirmed, isRegistered } =
    useUploader(uploadType);
  const { translate } = useTranslate();

  const onUploadCompleted = (mediaId: string) => {
    handleUploadCompleted(mediaId);
  };

  return (
    <BynderUploader onUploadCompleted={onUploadCompleted}>
      <Tooltip
        isOpen={canUseUploader ? false : undefined}
        content={
          <>
            <div>
              &bull; <Translate id="ASSET_PICKER_DROPDOWN.PERMISSION_1" />
            </div>
            <div>
              &bull; <Translate id="ASSET_PICKER_DROPDOWN.PERMISSION_2" />
            </div>
          </>
        }
        secondaryText={translate('ASSET_PICKER_DROPDOWN.PERMISSION_LABEL')}
      >
        <input
          type="file"
          onClick={handleClick}
          data-testid="imageUploaderInput"
          style={{ display: 'none' }}
        />
        <Button
          isDisabled={!canUseUploader || isConfirmed || isRegistered}
          icon={isConfirmed || isRegistered ? <Spinner /> : <IconUpload />}
          variant="secondary"
          onClick={handleClick}
        >
          <Translate id="PAGE_INSPECTOR.PERSONAL_UPLOAD" />
        </Button>
      </Tooltip>
    </BynderUploader>
  );
};
